import React, {useState} from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {DEFAULT_BLUE} from "../constants/general-constants";
import {HIGHLIGHT_COLOR} from "../constants/general-constants";

export default function SelectionToolOption({id, name, setFunction}){
	
	const WHITE = "#fff";
	const BLACK = "#000";
	
	const [backgroundColor, setBackgroundColor] = useState(WHITE);
	const [foregroundColor, setForegroundColor] = useState(BLACK);
	
	const thisContainer = {
		display:"flex",
		height:"40px",
		cursor:"pointer"
	}
	
	const iconContainer = {
		display:"flex",
		width:"40px",
		height:"40px",
		alignItems:"center",
		justifyContent:"space-around"
	};

	const iconStyle = {
		display:"flex",
		cursor:"pointer",
		width:"20px",
		height:"20px"
	};
	
	const titleContainer = {
		display:"flex",
		height:"100%",
		alignItems:"center",
		fontSize:"14px"
	};
	
	const handleClick = () => {
		setFunction(id);
	};
	
	const handleMouseOver = () => {
		setBackgroundColor(HIGHLIGHT_COLOR);
		setForegroundColor(BLACK);
	};
	
	const handleMouseLeave = () => {
		setBackgroundColor(WHITE);
		setForegroundColor(BLACK);
	};
	
	return (
		<div style={{...thisContainer, backgroundColor:backgroundColor}}
			onMouseOver={handleMouseOver}
			onMouseLeave={handleMouseLeave}
			onClick={handleClick}
			>
			<div style={iconContainer}>
				<FontAwesomeIcon icon="angle-right" style={{...iconStyle, color:foregroundColor}}/>
			</div>	
			<div style={{...titleContainer, color:foregroundColor}}>
				{name}
			</div>
		</div>
	);
}